import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-grid-ation-renderer',
  templateUrl:  './ag-grid-action-renderer.component.html',
  styleUrls: ['./ag-grid-action-renderer.component.scss']
})
export class AgGridActionsRendererComponent implements ICellRendererAngularComp {
  private params !: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  stopediting() {
    if(this.params.api.getSelectedRows().length && this.params.api.getSelectedRows()[0]?.prId === this.params.data.prId) {
      this.params.api.stopEditing();
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

}
